import React, { PureComponent } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import cn from 'classnames';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { func, bool } from 'prop-types';
import { FMessage } from '../../hoc/IntlComponents';

class PresetModal extends PureComponent {
  static propTypes = {
    onSave: func.isRequired,
    onCancel: func.isRequired,
    open: bool.isRequired,
    intl: intlShape.isRequired,
  };

  state = {
    errors: {},
    name: '',
  };

  toggleModal = () => {
    this.setState(() => ({ name: '', errors: {} }));
    this.props.onCancel();
  };

  handleChange = ({ target }) => {
    this.setState(() => ({
      [target.name]: target.value,
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { name } = this.state;
    const errors = {};

    if (!name) {
      errors.name = 'statistics.preset.modal.empty';
      this.setState(() => ({ errors }));
    } else {
      this.props.onSave(name);
      this.setState(() => ({ name: '', errors: {} }));
    }
  };

  render() {
    const { name, errors } = this.state;
    const { open, intl } = this.props;

    return (
      <Modal
        className="statistics-presets-modal"
        backdrop
        toggle={this.toggleModal}
        isOpen={open}
        centered
      >
        <Form onSubmit={this.handleSubmit} autoComplete="off">
          <ModalHeader toggle={this.toggleModal}>
            <FormattedMessage
              id="statistics.preset.modal.title"
              defaultMessage="Create new preset"
            />
          </ModalHeader>

          <ModalBody>
            <FormGroup className={cn('form-group-upper-label', { 'has-error': errors.name })}>
              <Label>
                <FormattedMessage
                  id="statistics.preset.modal.placeholder"
                  defaultMessage="Preset name"
                />
              </Label>

              <Input
                name="name"
                onChange={this.handleChange}
                // placeholder={intl.formatMessage({
                //   id: 'statistics.preset.modal.default-name',
                //   defaultMessage: 'My Preset',
                // })}
                value={name}
                autoFocus
              />
              {errors.name && (
                <small className="form-text">
                  <FMessage id={errors.name} />
                </small>
              )}
            </FormGroup>
          </ModalBody>

          <ModalFooter>
            {/* <Button type="button" size="sm" color="light" onClick={this.toggleModal}>
              <FormattedMessage id="main.cancel" defaultMessage="Cancel" />
            </Button>{' '} */}
            <Button disabled={!name} type="submit" size="sm" color="primary">
              <FormattedMessage id="main.save" defaultMessage="Save" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

export default injectIntl(PresetModal);
